import React,{useState} from "react";
import BlogCard from "./BlogCard";
import blogs from './BlogData';

export default function Blogs () {

  return (
    <div className="container py-4 my-5">
      <h2 className="text-center" ><span className="dark-blue">O</span><span className="light-blue">U</span><span className="dark-blue">R</span><span className="light-blue"> B</span><span className="dark-blue">L</span><span className="light-blue">O</span><span className="dark-blue">G</span><span className="light-blue">S</span></h2>
      <hr className="mt-3" />
      <div className="row my-4" >
          {
              blogs.map((blog)=>(
                  <div className="col my-4 d-flex justify-content-center">
                  <BlogCard blog={blog}/>
        </div>
              ))
          }

       
      </div>
    </div>
  );
};


